import { render } from "./FreelancersDataTable.vue?vue&type=template&id=061b4a26"
import script from "./FreelancersDataTable.vue?vue&type=script&lang=js"
export * from "./FreelancersDataTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__